import { render, staticRenderFns } from "./agregarProducto.vue?vue&type=template&id=3944dffe&scoped=true"
import script from "./agregarProducto.vue?vue&type=script&lang=js"
export * from "./agregarProducto.vue?vue&type=script&lang=js"
import style0 from "./agregarProducto.vue?vue&type=style&index=0&id=3944dffe&prod&scoped=true&lang=css"
import style1 from "./agregarProducto.vue?vue&type=style&index=1&id=3944dffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3944dffe",
  null
  
)

export default component.exports